// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
    border: 1px solid;
    border-radius: 8px;
    padding: 10px;
    display: flex;
    flex-direction: column;
}

.chat-messages {
    flex: 1;
    overflow-y: auto;
    padding: 5px;
    display: flex;
    flex-direction: column;
}

.message-input-container {
    width: 100%;
    margin-top: 10px;
    border: 1px solid;
    border-radius: 10px;
}

.message-input-container .disabled {
    background-color: #efefef4d;
    color: #1010104d;
    border-color: #efefef4d;
    cursor: auto;
}

.message-input-field {
    padding: 10px;
    border: none;
    display: block;
    resize: none;
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.message-input-field:focus {
    outline: none;
}

.message-input-button {
    background: none;
    border: none;
    cursor: pointer;
}

.input-with-icons {
    display: flex;
    justify-content: end;
    padding: 2px 10px;
}

.file-upload-button {
    background: none;
    border: none;
    cursor: pointer;
}

.file-preview-container {
    position: relative;
    display: inline-block;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 8px;
    max-width: 200px;
    margin: 10px;
}

.remove-file-button {
    position: absolute;
    top: -10px;
    right: -10px;
    background: #ff0000d6;
    border: 1px solid #e0e0e0;
    border-radius: 100%;
    height: 20px;
    width: 20px;
    cursor: pointer;
    padding: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.file-preview {
    display: flex;
    align-items: center;
    justify-content: center;
}

.file-preview svg {
    color: #fff;
    margin-right: 10px;
    background: #007bff;
    padding: 10px;
    border-radius: 5px;
}

.remove-file-button svg {
    color: #fff;
}

.file-preview-image {
    max-width: 100%;
    border-radius: 5px;
}

.file-name-preview {
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    color: #000;
}

.chat-bubble {
    max-width: 75%;
    margin-bottom: 10px;
    padding: 0px 10px 0px;
    border-radius: 12px;
    word-wrap: break-word;
}

.user .markdown-content a {
    color: #fff;
    text-decoration: underline;
}

.user .markdown-content a:hover {
    color: #212427;
}

.markdown-content code {
    background-color: rgba(0, 0, 0, 0.4);
    color: #ffffffda;
    padding: 2px 4px;
    border-radius: 4px;
}

.empty-chat {
    margin: 0 auto;
}

.actionBtnContainer {
    position: relative;
}

.dotsButton {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

.dotsButton:hover {
    background: #cccccc1f;
    border-radius: 50%;
    cursor: pointer;
}

.dropdown {
    position: relative;
    display: inline-block;
}

.dropdownMenu {
    position: absolute;
    background-color: white;
    width: 100px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.dropdownItem {
    padding: 8px 12px;
    background: none;
    border: none;
    text-align: left;
    width: 100%;
    cursor: pointer;
}

.dropdownItem:hover {
    background-color: #f1f1f1;
}

.markdown-content table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    margin-bottom: 10px;
}

.markdown-content th, .markdown-content td {
    border: 1px solid #ddd;
    padding: 15px;
    text-align: left;
}

.markdown-content th {
    background-color: #007bff;
    color: white;
}

.markdown-content tr:nth-child(even) {
    background-color: #f2f2f2;
}

.markdown-content tr:hover {
    background-color: #ddd;
}
`, "",{"version":3,"sources":["webpack://./src/styles/chatStyles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".chat-container {\n    border: 1px solid;\n    border-radius: 8px;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n}\n\n.chat-messages {\n    flex: 1;\n    overflow-y: auto;\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n}\n\n.message-input-container {\n    width: 100%;\n    margin-top: 10px;\n    border: 1px solid;\n    border-radius: 10px;\n}\n\n.message-input-container .disabled {\n    background-color: #efefef4d;\n    color: #1010104d;\n    border-color: #efefef4d;\n    cursor: auto;\n}\n\n.message-input-field {\n    padding: 10px;\n    border: none;\n    display: block;\n    resize: none;\n    width: 100%;\n    height: 80px;\n    box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n}\n\n.message-input-field:focus {\n    outline: none;\n}\n\n.message-input-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.input-with-icons {\n    display: flex;\n    justify-content: end;\n    padding: 2px 10px;\n}\n\n.file-upload-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.file-preview-container {\n    position: relative;\n    display: inline-block;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    max-width: 200px;\n    margin: 10px;\n}\n\n.remove-file-button {\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    background: #ff0000d6;\n    border: 1px solid #e0e0e0;\n    border-radius: 100%;\n    height: 20px;\n    width: 20px;\n    cursor: pointer;\n    padding: 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.file-preview {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.file-preview svg {\n    color: #fff;\n    margin-right: 10px;\n    background: #007bff;\n    padding: 10px;\n    border-radius: 5px;\n}\n\n.remove-file-button svg {\n    color: #fff;\n}\n\n.file-preview-image {\n    max-width: 100%;\n    border-radius: 5px;\n}\n\n.file-name-preview {\n    font-size: 14px;\n    font-weight: 700;\n    text-align: center;\n    color: #000;\n}\n\n.chat-bubble {\n    max-width: 75%;\n    margin-bottom: 10px;\n    padding: 0px 10px 0px;\n    border-radius: 12px;\n    word-wrap: break-word;\n}\n\n.user .markdown-content a {\n    color: #fff;\n    text-decoration: underline;\n}\n\n.user .markdown-content a:hover {\n    color: #212427;\n}\n\n.markdown-content code {\n    background-color: rgba(0, 0, 0, 0.4);\n    color: #ffffffda;\n    padding: 2px 4px;\n    border-radius: 4px;\n}\n\n.empty-chat {\n    margin: 0 auto;\n}\n\n.actionBtnContainer {\n    position: relative;\n}\n\n.dotsButton {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n}\n\n.dotsButton:hover {\n    background: #cccccc1f;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n.dropdownMenu {\n    position: absolute;\n    background-color: white;\n    width: 100px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n}\n\n.dropdownItem {\n    padding: 8px 12px;\n    background: none;\n    border: none;\n    text-align: left;\n    width: 100%;\n    cursor: pointer;\n}\n\n.dropdownItem:hover {\n    background-color: #f1f1f1;\n}\n\n.markdown-content table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.markdown-content th, .markdown-content td {\n    border: 1px solid #ddd;\n    padding: 15px;\n    text-align: left;\n}\n\n.markdown-content th {\n    background-color: #007bff;\n    color: white;\n}\n\n.markdown-content tr:nth-child(even) {\n    background-color: #f2f2f2;\n}\n\n.markdown-content tr:hover {\n    background-color: #ddd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
